import classNames from 'classnames';
import React, { lazy, Suspense, useMemo } from 'react';
import { pickDomAttrs } from '../_util/utils';
import Result from '../result';
import Space from '../space';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const loadIcon = (status, isPartner) => {
  if (isPartner) {
    switch (status) {
      case '403':
        return /*#__PURE__*/lazy(() => import('./icon').then(module => ({
          default: module.PartnerIcon_403
        })));
      case '404':
        return /*#__PURE__*/lazy(() => import('./icon').then(module => ({
          default: module.PartnerIcon_404
        })));
      case '503':
        return /*#__PURE__*/lazy(() => import('./icon').then(module => ({
          default: module.PartnerIcon_503
        })));
    }
  } else {
    switch (status) {
      case '403':
        return /*#__PURE__*/lazy(() => import('./icon').then(module => ({
          default: module.Icon_403
        })));
      case '404':
        return /*#__PURE__*/lazy(() => import('./icon').then(module => ({
          default: module.Icon_404
        })));
      case '503':
        return /*#__PURE__*/lazy(() => import('./icon').then(module => ({
          default: module.Icon_503
        })));
      case '504':
        return /*#__PURE__*/lazy(() => import('./icon').then(module => ({
          default: module.Icon_504
        })));
    }
  }
  return () => null;
};
const Abnormal = props => {
  const {
    isPartner,
    status,
    title,
    subTitle,
    extra,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-abnormal");
  const attrs = pickDomAttrs(restProps);
  const Icon = useMemo(() => loadIcon(status, isPartner), [isPartner, status]);
  return /*#__PURE__*/_jsx("div", {
    ...attrs.data,
    className: classNames(baseClassName, className),
    style: style,
    children: /*#__PURE__*/_jsx(Result, {
      icon: /*#__PURE__*/_jsxs(Space, {
        direction: "vertical",
        children: [/*#__PURE__*/_jsx(Suspense, {
          fallback: null,
          children: /*#__PURE__*/_jsx(Icon, {})
        }), /*#__PURE__*/_jsx("div", {
          className: "status",
          children: status
        })]
      }),
      title: title,
      subTitle: subTitle,
      extra: extra
    })
  });
};
export default Abnormal;